import { LoyaltyLevelType, LoyaltyLevelWithRangeType } from '../../types'

export const getLevelsWithRanges = (levels: LoyaltyLevelType[]): LoyaltyLevelWithRangeType[] =>
  levels.map((level, index) => ({
    ...level,
    ftdRange: {
      from: level.ftd_count,
      to: levels[index + 1] ? levels[index + 1].ftd_count - 1 : Number.POSITIVE_INFINITY,
    },
  }))
